export const ROUTES = {
  HOME: '',
  ABOUT: 'about',
  SERVICES: 'services',
  CONTACT: 'contact',
  BLOG: 'blog',
  BLOG_POST: ':id',
  ROLE_SELECTION: 'role-selection',
  DRIVER: 'driver',
  CONTRACTOR: 'contractor',
  PRIVACY: 'privacy',
  TERMS: 'terms',
  EULA: 'eula',
  NOT_FOUND: '**',
};
